var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-vcenter"},[_c('h2',[_vm._t("titre",function(){return [_vm._v(" Informations ")]})],2),(_vm.$slots.details)?_c('div',{staticClass:"details"},[_vm._t("details")],2):_vm._e(),_c('div',{staticClass:"tab-content"},[_vm._t("content")],2),(_vm.$slots.buttons)?_c('div',{staticClass:"buttons"},[_vm._t("buttons")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }